import React from 'react';
import { Modal, Button, Form, Table, Spinner, Alert } from 'react-bootstrap';

const formatDate = (dateString) => {
    if (!dateString) return '--';
    try {
        const date = new Date(dateString);
        return date.toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    } catch {
        return '--';
    }
};

const AddCommentModal = ({ show, onHide, selectedCase, newComment, setNewComment, submitAddComment, loading, comments, loadingComments }) => (
  <Modal show={show} onHide={onHide} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>
        Case Comments
        {selectedCase && (
            <div className="text-muted fs-6 mt-1">
                {selectedCase.customer_name} ({selectedCase.lan_number})
            </div>
        )}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h5 className="mb-3">Previous Comments</h5>
      <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {loadingComments ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Loading comments...</p>
          </div>
        ) : !comments || comments.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No previous comments found for this case.</p>
          </div>
        ) : comments && comments.length > 0 ? (
          <Table striped hover>
            <thead className="table-gray">
              <tr>
                <th>Comment</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {comments.map((comment, index) => (
                <tr key={index}>
                  <td>{comment.comment}</td>
                  <td><small className="text-muted">{formatDate(comment.created_at)}</small></td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : null}
      </div>

      <hr className="my-4" />

      <h5 className="mb-3">Add New Comment</h5>
      <Form.Group className="mb-3">
        <Form.Label>Comment *</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Type your comment here..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          disabled={loading}
        />
      </Form.Group>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={loading}>Close</Button>
      <Button variant="primary" onClick={submitAddComment} disabled={loading || !newComment.trim()}>
        {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />}
        {loading ? 'Submitting...' : 'Add Comment'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default AddCommentModal;